module.exports = __webpack_public_path__ + "img/bdns4.8db4fe71.webp";